import { gql, useQuery } from '@apollo/client';
import React from 'react';

import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { SHA256 } from 'src/lib/graphqlTypes/customScalarTypes';

import { EmptyBuildErrors } from '../../buildCheckDetails/emptyBuildErrors/EmptyBuildErrors';

export const FilterBuildSuccess = ({
  graphId,
  builtSchemaHash,
}: {
  graphId: string;
  builtSchemaHash: SHA256['output'];
}) => {
  const { data, error } = useQuery<
    GraphQLTypes.SupergraphShemaByHash,
    GraphQLTypes.SupergraphShemaByHashVariables
  >(
    gql`
      query SupergraphShemaByHash($graphId: ID!, $hash: SHA256!) {
        service(id: $graphId) {
          id
          document(hash: $hash)
        }
      }
    `,
    {
      variables: { graphId, hash: builtSchemaHash },
      context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
    },
  );

  if (error) throw error;

  return (
    <EmptyBuildErrors
      graphId={graphId}
      supergraphSdl={data?.service?.document}
    />
  );
};
